import React from "react"
import "./frames.css"

const DatosEconomicos = () => {
  return (
    <div className="frames-container">
      <h1 className="frames-title">Datos Económicos</h1>
      <p className="frames-text">
        Te ayudamos a conocer cuáles son las partidas económicas fundamentales a
        tener en cuenta y su valor monetario actual aproximado. De esta manera
        podrás desarrollar un bussiness plan acertado para asegurar el futuro
        éxito de tu unidad de medicina hiperbárica.
      </p>
    </div>
  )
}

export default DatosEconomicos
